import React, { useContext, useEffect, useRef } from 'react';

// For mocking
let isForcingPublic = false;
export const useForcePublicViewEffect = () => {
  const previousValue = useRef<boolean | undefined>(undefined);

  if (previousValue.current === undefined) {
    previousValue.current = isForcingPublic;
    isForcingPublic = true;
  }

  useEffect(
    () => () => {
      isForcingPublic = !!previousValue.current;
    },
    [],
  );
};

const IsPublicViewContext = React.createContext(false);

interface PublicViewProviderProps {
  children: React.ReactNode;
  publicView: boolean;
}

export const IsPublicViewProvider = ({
  children,
  publicView,
}: PublicViewProviderProps) => (
  <IsPublicViewContext.Provider value={publicView}>
    {children}
  </IsPublicViewContext.Provider>
);

const useIsPublicView = () => {
  const isPublicView = useContext(IsPublicViewContext);

  if (isForcingPublic) {
    return true;
  }
  return isPublicView;
};

export default useIsPublicView;
